// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../shared/font/gteestiprodisplay_regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../shared/font/gteestiprodisplay_bold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "GteDisplayBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "GteDisplayExtra";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
.selectCountries_body__noZUa {
  padding: 5px;
  display: flex;
  align-items: center;
  grid-gap: 6px;
  background: #FAFAFA;
  padding-left: 16px;
  border-radius: 30px 0 0 30px;
}
.selectCountries_body__noZUa img {
  border-radius: 5px;
}
.selectCountries_body__noZUa .selectCountries_list__mpTqC {
  border-radius: 10px;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
  background: #FAFAFA;
  padding: 8px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  overflow: auto;
}
.selectCountries_body__noZUa .selectCountries_list__mpTqC.selectCountries_hide__ObDw- {
  display: none;
}
.selectCountries_body__noZUa .selectCountries_list__mpTqC .selectCountries_wrapper__H3DJu {
  display: flex;
  flex-direction: column;
  grid-gap: 15px;
  margin-top: 10px;
}
.selectCountries_body__noZUa .selectCountries_list__mpTqC .selectCountries_searchCountry__j\\+m4T {
  width: 100%;
  margin: 10px 0;
  display: flex;
  align-items: center;
  grid-gap: 10px;
  justify-content: space-between;
}
.selectCountries_body__noZUa .selectCountries_list__mpTqC .selectCountries_searchCountry__j\\+m4T input {
  border: none;
  outline: none;
  background: #FAFAFA;
  width: 100%;
  padding: 17px 20px 12px 17px;
  border-radius: 0 30px 30px 0;
  font-family: GteDisplayBold;
  font-weight: 500;
  font-size: 16px;
}
.selectCountries_body__noZUa .selectCountries_list__mpTqC .selectCountries_searchCountry__j\\+m4T input::placeholder {
  color: #C2C2C2;
}
.selectCountries_body__noZUa .selectCountries_list__mpTqC .selectCountries_listItem__TYgrx {
  display: flex;
  align-items: center;
  grid-gap: 8px;
}
.selectCountries_body__noZUa .selectCountries_list__mpTqC .selectCountries_listItem__TYgrx p {
  font-size: 15px;
}
.selectCountries_body__noZUa p {
  font-size: 16px;
  font-weight: 500;
  color: #000;
  font-family: GteDisplayBold;
  margin: 5px 0 0 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/selectCountries/selectCountries.module.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AACF;AACA;EACE,8BAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AACF;AAEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;AAAF;AAEE;EACE,kBAAA;AAAJ;AAEE;EACE,mBAAA;EAGA,gDAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,cAAA;AAAJ;AACI;EACE,aAAA;AACN;AACI;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AACN;AAEI;EACE,WAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,8BAAA;AAAN;AACM;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4BAAA;EACA,4BAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;AACR;AAAQ;EACE,cAAA;AAEV;AAII;EACE,aAAA;EACA,mBAAA;EACA,aAAA;AAFN;AAIM;EACE,eAAA;AAFR;AAOE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,2BAAA;EACA,mBAAA;AALJ","sourcesContent":["@font-face {\r\n  font-family: \"GteDisplayBold\";\r\n  src: url('../../shared/font/gteestiprodisplay_regular.otf') format(\"truetype\");\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n@font-face {\r\n  font-family: \"GteDisplayExtra\";\r\n  src: url('../../shared/font/gteestiprodisplay_bold.otf') format(\"truetype\");\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n\r\n.body {\r\n  padding: 5px;\r\n  display: flex;\r\n  align-items: center;\r\n  grid-gap: 6px;\r\n  background: #FAFAFA;\r\n  padding-left: 16px;\r\n  border-radius: 30px 0 0 30px;\r\n\r\n  img {\r\n    border-radius: 5px;\r\n  }\r\n  .list {\r\n    border-radius: 10px;\r\n    -webkit-box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.75);\r\n    -moz-box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.75);\r\n    box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.75);\r\n    background: #FAFAFA;\r\n    padding: 8px;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    z-index: 1000;\r\n    overflow: auto;\r\n    &.hide {\r\n      display: none;\r\n    }\r\n    .wrapper {\r\n      display: flex;\r\n      flex-direction: column;\r\n      grid-gap: 15px;\r\n      margin-top: 10px;\r\n    }\r\n\r\n    .searchCountry {\r\n      width: 100%;\r\n      margin: 10px 0;\r\n      display: flex;\r\n      align-items: center;\r\n      grid-gap: 10px;\r\n      justify-content: space-between;\r\n      input {\r\n        border: none;\r\n        outline: none;\r\n        background: #FAFAFA;\r\n        width: 100%;\r\n        padding: 17px 20px 12px 17px;\r\n        border-radius: 0 30px 30px 0;\r\n        font-family: GteDisplayBold;\r\n        font-weight: 500;\r\n        font-size: 16px;\r\n        &::placeholder {\r\n          color: #C2C2C2;\r\n\r\n        }\r\n      }\r\n    }\r\n\r\n    .listItem {\r\n      display: flex;\r\n      align-items: center;\r\n      grid-gap: 8px;\r\n\r\n      p {\r\n        font-size: 15px;\r\n      }\r\n    }\r\n  }\r\n  \r\n  p {\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    color: #000;\r\n    font-family: GteDisplayBold;\r\n    margin: 5px 0 0 5px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `selectCountries_body__noZUa`,
	"list": `selectCountries_list__mpTqC`,
	"hide": `selectCountries_hide__ObDw-`,
	"wrapper": `selectCountries_wrapper__H3DJu`,
	"searchCountry": `selectCountries_searchCountry__j+m4T`,
	"listItem": `selectCountries_listItem__TYgrx`
};
export default ___CSS_LOADER_EXPORT___;
